module.exports = __webpack_public_path__ + "img/new-logo-white.ec2aa7b9.png";